import { IoIosArrowForward } from 'react-icons/io';
import { DARK_GRAY } from '../../../styles/constants/color';
import styled from '@emotion/styled';

const ArrowWrapper = styled.div`
  width: auto;
  height: auto;
`;

interface Props {
  arrowSize?: number;
  arrowColour?: string;
}

/**
 *  테이블속 설렉트 박스를 가르키는 화살표 이미지
 * @param {number} arrowSize 화살표 이미지 크기 (기본값 18)
 * @param {string} arrowColour 화살표 이미지 색상 (기본값 #666)
 *  */
function IconArrowSelect({ arrowSize = 18, arrowColour = DARK_GRAY }: Props) {
  return (
    <ArrowWrapper className='arrow-wrapper'>
      <IoIosArrowForward size={arrowSize} color={arrowColour} textAnchor='right' />
    </ArrowWrapper>
  );
}

export default IconArrowSelect;
